export var SupplierInclude = {
    logo: true,
    solutions: true,
    organization: true,
    businessUnit: true,
    internalSupplier: true,
};
//# sourceMappingURL=Supplier.js.map